// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ImageTaskNode 样式 */
.ImageTaskNode-wrapper {
  width: 360px;
  max-width: 100%;
}

/* 头部 */
.ImageTaskNode-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 12px;
  padding-bottom: 12px;
  border-bottom: 1px solid #e5e7eb;
}

.ImageTaskNode-charge {
  margin: 8px 0;
  padding: 6px 10px;
  border-radius: 6px;
  color: #92400e;
  background: #fffbeb;
  font-size: 12px;
  font-weight: 600;
}

.ImageTaskNode-task-id {
  font-size: 11px;
  color: #6b7280;
  font-family: 'Courier New', monospace;
}

.ImageTaskNode-status-badge {
  padding: 4px 10px;
  border-radius: 12px;
  font-size: 11px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.ImageTaskNode-status-pending {
  background: #fef3c7;
  color: #92400e;
}

.ImageTaskNode-status-processing {
  background: #dbeafe;
  color: #1e40af;
}

.ImageTaskNode-status-completed {
  background: #d1fae5;
  color: #065f46;
}

.ImageTaskNode-status-failed {
  background: #fee2e2;
  color: #991b1b;
}

/* 转存提示（静默） */
.ImageTaskNode-transfer-hint {
  margin-top: -8px;
  margin-bottom: 12px;
  padding: 6px 10px;
  background: #f0f9ff;
  border: 1px solid #e0f2fe;
  border-radius: 6px;
  font-size: 11px;
  color: #0c4a6e;
  text-align: center;
  opacity: 0.8;
}

/* 参数信息 */
.ImageTaskNode-params {
  margin-bottom: 12px;
  padding: 10px;
  background: #f9fafb;
  border: 1px solid #e5e7eb;
  border-radius: 6px;
}

.ImageTaskNode-params-title {
  font-size: 12px;
  font-weight: 600;
  color: #374151;
  margin-bottom: 8px;
}

.ImageTaskNode-params-grid {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  margin-bottom: 8px;
}

.ImageTaskNode-param-item {
  display: flex;
  align-items: center;
  gap: 4px;
  font-size: 11px;
}

.ImageTaskNode-param-label {
  color: #6b7280;
}

.ImageTaskNode-param-value {
  color: #374151;
  font-weight: 500;
}

.ImageTaskNode-prompt {
  margin-top: 8px;
  padding-top: 8px;
  border-top: 1px solid #e5e7eb;
}

.ImageTaskNode-prompt-label {
  font-size: 11px;
  color: #6b7280;
  margin-bottom: 4px;
}

.ImageTaskNode-prompt-text {
  font-size: 12px;
  color: #374151;
  line-height: 1.5;
  max-height: 80px;
  overflow-y: auto;
  padding: 6px;
  background: white;
  border-radius: 4px;
  word-break: break-word;
}

/* 加载状态 */
.ImageTaskNode-loading {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 20px;
  background: #f0f9ff;
  border: 1px solid #bae6fd;
  border-radius: 8px;
  margin-bottom: 12px;
}

.ImageTaskNode-spinner {
  width: 32px;
  height: 32px;
  border: 3px solid #e0f2fe;
  border-top-color: #0284c7;
  border-radius: 50%;
  animation: ImageTaskNode-spin 0.8s linear infinite;
}

@keyframes ImageTaskNode-spin {
  to { transform: rotate(360deg); }
}

.ImageTaskNode-loading-text {
  margin-top: 12px;
  font-size: 13px;
  color: #0c4a6e;
  font-weight: 500;
}

.ImageTaskNode-refresh-button {
  margin-top: 12px;
  padding: 6px 12px;
  background: white;
  color: #0284c7;
  border: 1px solid #bae6fd;
  border-radius: 6px;
  font-size: 12px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s;
}

.ImageTaskNode-refresh-button:hover {
  background: #f0f9ff;
  border-color: #0284c7;
}

/* 生成结果 */
.ImageTaskNode-results {
  margin-bottom: 12px;
}

.ImageTaskNode-results-title {
  font-size: 13px;
  font-weight: 600;
  color: #374151;
  margin-bottom: 10px;
}

.ImageTaskNode-images {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.ImageTaskNode-image-item {
  position: relative;
  border-radius: 8px;
  overflow: hidden;
  border: 1px solid #e5e7eb;
  background: white;
}

.ImageTaskNode-image {
  width: 100%;
  display: block;
}

.ImageTaskNode-image-info {
  padding: 6px 8px;
  background: rgba(0, 0, 0, 0.05);
  font-size: 11px;
  color: #6b7280;
  text-align: center;
}

.ImageTaskNode-download-link {
  display: block;
  width: 100%;
  padding: 8px;
  text-align: center;
  background: #f9fafb;
  color: #374151;
  text-decoration: none;
  font-size: 12px;
  font-weight: 500;
  transition: background 0.2s;
  border: none;
  cursor: pointer;
  font-family: inherit;
}

.ImageTaskNode-download-link:hover {
  background: #e5e7eb;
  color: #1f2937;
}

.ImageTaskNode-download-link:active {
  background: #d1d5db;
}

/* 错误状态 */
.ImageTaskNode-error {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 20px;
  background: #fef2f2;
  border: 1px solid #fecaca;
  border-radius: 8px;
  margin-bottom: 12px;
}

.ImageTaskNode-error-icon {
  font-size: 32px;
  margin-bottom: 8px;
}

.ImageTaskNode-error-text {
  font-size: 13px;
  color: #991b1b;
  text-align: center;
  margin-bottom: 12px;
  line-height: 1.5;
}

.ImageTaskNode-retry-button {
  padding: 6px 12px;
  background: white;
  color: #dc2626;
  border: 1px solid #fecaca;
  border-radius: 6px;
  font-size: 12px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s;
}

.ImageTaskNode-retry-button:hover {
  background: #fef2f2;
  border-color: #dc2626;
}

/* 性能指标 */
.ImageTaskNode-metrics {
  padding: 10px;
  background: #fefce8;
  border: 1px solid #fef08a;
  border-radius: 6px;
  margin-top: 12px;
}

.ImageTaskNode-metrics-title {
  font-size: 12px;
  font-weight: 600;
  color: #713f12;
  margin-bottom: 8px;
}

.ImageTaskNode-metrics-grid {
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
}

.ImageTaskNode-metric-item {
  display: flex;
  flex-direction: column;
  gap: 2px;
}

.ImageTaskNode-metric-label {
  font-size: 10px;
  color: #92400e;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.ImageTaskNode-metric-value {
  font-size: 13px;
  color: #713f12;
  font-weight: 600;
}
`, "",{"version":3,"sources":["webpack://./src/components/canvas/nodes/ImageTaskNode.css"],"names":[],"mappings":"AAAA,qBAAqB;AACrB;EACE,YAAY;EACZ,eAAe;AACjB;;AAEA,OAAO;AACP;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;EACnB,oBAAoB;EACpB,gCAAgC;AAClC;;AAEA;EACE,aAAa;EACb,iBAAiB;EACjB,kBAAkB;EAClB,cAAc;EACd,mBAAmB;EACnB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,qCAAqC;AACvC;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA,aAAa;AACb;EACE,gBAAgB;EAChB,mBAAmB;EACnB,iBAAiB;EACjB,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,cAAc;EACd,kBAAkB;EAClB,YAAY;AACd;;AAEA,SAAS;AACT;EACE,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,QAAQ;EACR,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;AACjB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,6BAA6B;AAC/B;;AAEA;EACE,eAAe;EACf,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;EAChB,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA,SAAS;AACT;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,yBAAyB;EACzB,kBAAkB;EAClB,kDAAkD;AACpD;;AAEA;EACE,KAAK,yBAAyB,EAAE;AAClC;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,iBAAiB;EACjB,cAAc;EACd,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA,SAAS;AACT;EACE,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;EACzB,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,+BAA+B;EAC/B,eAAe;EACf,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;EACd,qBAAqB;EACrB,eAAe;EACf,gBAAgB;EAChB,2BAA2B;EAC3B,YAAY;EACZ,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA,SAAS;AACT;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,iBAAiB;EACjB,cAAc;EACd,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA,SAAS;AACT;EACE,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,cAAc;EACd,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB","sourcesContent":["/* ImageTaskNode 样式 */\n.ImageTaskNode-wrapper {\n  width: 360px;\n  max-width: 100%;\n}\n\n/* 头部 */\n.ImageTaskNode-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 12px;\n  padding-bottom: 12px;\n  border-bottom: 1px solid #e5e7eb;\n}\n\n.ImageTaskNode-charge {\n  margin: 8px 0;\n  padding: 6px 10px;\n  border-radius: 6px;\n  color: #92400e;\n  background: #fffbeb;\n  font-size: 12px;\n  font-weight: 600;\n}\n\n.ImageTaskNode-task-id {\n  font-size: 11px;\n  color: #6b7280;\n  font-family: 'Courier New', monospace;\n}\n\n.ImageTaskNode-status-badge {\n  padding: 4px 10px;\n  border-radius: 12px;\n  font-size: 11px;\n  font-weight: 600;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n}\n\n.ImageTaskNode-status-pending {\n  background: #fef3c7;\n  color: #92400e;\n}\n\n.ImageTaskNode-status-processing {\n  background: #dbeafe;\n  color: #1e40af;\n}\n\n.ImageTaskNode-status-completed {\n  background: #d1fae5;\n  color: #065f46;\n}\n\n.ImageTaskNode-status-failed {\n  background: #fee2e2;\n  color: #991b1b;\n}\n\n/* 转存提示（静默） */\n.ImageTaskNode-transfer-hint {\n  margin-top: -8px;\n  margin-bottom: 12px;\n  padding: 6px 10px;\n  background: #f0f9ff;\n  border: 1px solid #e0f2fe;\n  border-radius: 6px;\n  font-size: 11px;\n  color: #0c4a6e;\n  text-align: center;\n  opacity: 0.8;\n}\n\n/* 参数信息 */\n.ImageTaskNode-params {\n  margin-bottom: 12px;\n  padding: 10px;\n  background: #f9fafb;\n  border: 1px solid #e5e7eb;\n  border-radius: 6px;\n}\n\n.ImageTaskNode-params-title {\n  font-size: 12px;\n  font-weight: 600;\n  color: #374151;\n  margin-bottom: 8px;\n}\n\n.ImageTaskNode-params-grid {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 8px;\n  margin-bottom: 8px;\n}\n\n.ImageTaskNode-param-item {\n  display: flex;\n  align-items: center;\n  gap: 4px;\n  font-size: 11px;\n}\n\n.ImageTaskNode-param-label {\n  color: #6b7280;\n}\n\n.ImageTaskNode-param-value {\n  color: #374151;\n  font-weight: 500;\n}\n\n.ImageTaskNode-prompt {\n  margin-top: 8px;\n  padding-top: 8px;\n  border-top: 1px solid #e5e7eb;\n}\n\n.ImageTaskNode-prompt-label {\n  font-size: 11px;\n  color: #6b7280;\n  margin-bottom: 4px;\n}\n\n.ImageTaskNode-prompt-text {\n  font-size: 12px;\n  color: #374151;\n  line-height: 1.5;\n  max-height: 80px;\n  overflow-y: auto;\n  padding: 6px;\n  background: white;\n  border-radius: 4px;\n  word-break: break-word;\n}\n\n/* 加载状态 */\n.ImageTaskNode-loading {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  padding: 20px;\n  background: #f0f9ff;\n  border: 1px solid #bae6fd;\n  border-radius: 8px;\n  margin-bottom: 12px;\n}\n\n.ImageTaskNode-spinner {\n  width: 32px;\n  height: 32px;\n  border: 3px solid #e0f2fe;\n  border-top-color: #0284c7;\n  border-radius: 50%;\n  animation: ImageTaskNode-spin 0.8s linear infinite;\n}\n\n@keyframes ImageTaskNode-spin {\n  to { transform: rotate(360deg); }\n}\n\n.ImageTaskNode-loading-text {\n  margin-top: 12px;\n  font-size: 13px;\n  color: #0c4a6e;\n  font-weight: 500;\n}\n\n.ImageTaskNode-refresh-button {\n  margin-top: 12px;\n  padding: 6px 12px;\n  background: white;\n  color: #0284c7;\n  border: 1px solid #bae6fd;\n  border-radius: 6px;\n  font-size: 12px;\n  font-weight: 500;\n  cursor: pointer;\n  transition: all 0.2s;\n}\n\n.ImageTaskNode-refresh-button:hover {\n  background: #f0f9ff;\n  border-color: #0284c7;\n}\n\n/* 生成结果 */\n.ImageTaskNode-results {\n  margin-bottom: 12px;\n}\n\n.ImageTaskNode-results-title {\n  font-size: 13px;\n  font-weight: 600;\n  color: #374151;\n  margin-bottom: 10px;\n}\n\n.ImageTaskNode-images {\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n}\n\n.ImageTaskNode-image-item {\n  position: relative;\n  border-radius: 8px;\n  overflow: hidden;\n  border: 1px solid #e5e7eb;\n  background: white;\n}\n\n.ImageTaskNode-image {\n  width: 100%;\n  display: block;\n}\n\n.ImageTaskNode-image-info {\n  padding: 6px 8px;\n  background: rgba(0, 0, 0, 0.05);\n  font-size: 11px;\n  color: #6b7280;\n  text-align: center;\n}\n\n.ImageTaskNode-download-link {\n  display: block;\n  width: 100%;\n  padding: 8px;\n  text-align: center;\n  background: #f9fafb;\n  color: #374151;\n  text-decoration: none;\n  font-size: 12px;\n  font-weight: 500;\n  transition: background 0.2s;\n  border: none;\n  cursor: pointer;\n  font-family: inherit;\n}\n\n.ImageTaskNode-download-link:hover {\n  background: #e5e7eb;\n  color: #1f2937;\n}\n\n.ImageTaskNode-download-link:active {\n  background: #d1d5db;\n}\n\n/* 错误状态 */\n.ImageTaskNode-error {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  padding: 20px;\n  background: #fef2f2;\n  border: 1px solid #fecaca;\n  border-radius: 8px;\n  margin-bottom: 12px;\n}\n\n.ImageTaskNode-error-icon {\n  font-size: 32px;\n  margin-bottom: 8px;\n}\n\n.ImageTaskNode-error-text {\n  font-size: 13px;\n  color: #991b1b;\n  text-align: center;\n  margin-bottom: 12px;\n  line-height: 1.5;\n}\n\n.ImageTaskNode-retry-button {\n  padding: 6px 12px;\n  background: white;\n  color: #dc2626;\n  border: 1px solid #fecaca;\n  border-radius: 6px;\n  font-size: 12px;\n  font-weight: 500;\n  cursor: pointer;\n  transition: all 0.2s;\n}\n\n.ImageTaskNode-retry-button:hover {\n  background: #fef2f2;\n  border-color: #dc2626;\n}\n\n/* 性能指标 */\n.ImageTaskNode-metrics {\n  padding: 10px;\n  background: #fefce8;\n  border: 1px solid #fef08a;\n  border-radius: 6px;\n  margin-top: 12px;\n}\n\n.ImageTaskNode-metrics-title {\n  font-size: 12px;\n  font-weight: 600;\n  color: #713f12;\n  margin-bottom: 8px;\n}\n\n.ImageTaskNode-metrics-grid {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 12px;\n}\n\n.ImageTaskNode-metric-item {\n  display: flex;\n  flex-direction: column;\n  gap: 2px;\n}\n\n.ImageTaskNode-metric-label {\n  font-size: 10px;\n  color: #92400e;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n}\n\n.ImageTaskNode-metric-value {\n  font-size: 13px;\n  color: #713f12;\n  font-weight: 600;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
